module.exports = __webpack_public_path__ + "img/migather.9acc2795.png";